import { useMarketByIdQuery } from "Market/Api/Query/useMarketByIdQuery";
import {
	getMarketEditTabs,
	type MarketEditTabs,
} from "Market/Components/Tabs/Hooks/useMarketEditTabs";
import { Tabs } from "Shared/Components/Tabs";
import { getTabPanelElement } from "Shared/Components/Tabs/Helpers/getTabPanelElement";
import { useNavigateTabs } from "Shared/Components/Tabs/Hooks/useNavigateTabs";
import { Box, CircularProgress, Stack } from "@mui/material";
import type { FC } from "react";

type Props = {
	urlPath: string;
	currentTab: MarketEditTabs;
};

export const MarketEdit: FC<Props> = ({ urlPath, currentTab }) => {
	const { data: market, isLoading } = useMarketByIdQuery(urlPath);
	const tabs = getMarketEditTabs(urlPath);

	if (isLoading)
		return (
			<Stack width="100%" alignItems="center" justifyContent="center">
				<CircularProgress />
			</Stack>
		);

	return (
		<Box
			width="100%"
			sx={{
				marginTop: "0 !important",
				px: { xs: 1, md: 3 },
				py: 2,
			}}
		>
			{market && (
				<Tabs
					value={currentTab}
					tabs={tabs}
					mapItem={(tab) => getTabPanelElement(tab, market)}
					hookFunction={useNavigateTabs}
				/>
			)}
		</Box>
	);
};
